import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as LayersIcon } from './layers.svg';

export const Layers = IconHOC(LayersIcon);
